export default "__VITE_ASSET__e5c579bf__"